module.exports = __webpack_public_path__ + "img/subBanner2.a8499318.png";